import { render, staticRenderFns } from "./select-dialog.vue?vue&type=template&id=488c638c&scoped=true&"
import script from "./select-dialog.vue?vue&type=script&lang=js&"
export * from "./select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./select-dialog.vue?vue&type=style&index=0&id=488c638c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c638c",
  null
  
)

export default component.exports